import { useNavigate } from 'react-router-dom';
import { GoogleButton } from '@/components/ui';
import { useModal } from '@/hooks/useModal';
import ProfessionalTermsOfUsePage from '@/pages/professional-terms-of-use';
import { Helmet } from 'react-helmet-async';
import { Header } from '@/pages/public/landing/components/Header';

const ProfessionalRegister = () => {
	const navigate = useNavigate();
	const { openModal } = useModal();

	return (
		<div className="flex min-h-screen flex-col overflow-y-auto bg-[#f8f9fa] font-sans">
			<Helmet>
				<title>Cadastre-se como Profissional | Plumaa</title>
				<meta
					name="description"
					content="Junte-se à Plumaa. Cadastro gratuito para psicólogos e psiquiatras atenderem pacientes online com segurança e praticidade."
				/>
			</Helmet>

			<Header />

			<main className="flex flex-1 items-center justify-center p-4">
				<div className="flex w-full max-w-[440px] flex-col gap-6 rounded-[2rem] bg-white p-6 shadow-sm md:p-10">
					<div className="space-y-1 text-center">
						<h1 className="text-2xl font-black tracking-tight text-zinc-900 md:text-3xl">
							Criar conta como Profissional
						</h1>
						<p className="text-xs font-medium text-zinc-400 md:text-sm">
							Inicie seu cadastro para atender pela Plumaa.
						</p>
					</div>

					<div className="w-full">
						<div className="flex w-full justify-center gap-1 rounded-xl bg-zinc-100 p-1.5">
							<button
								type="button"
								className="w-full cursor-pointer rounded-lg border-none bg-white px-0 py-2 text-center text-sm font-bold text-zinc-900 shadow-sm focus:outline-none"
							>
								Cadastro
							</button>
							<button
								type="button"
								className="w-full cursor-pointer rounded-lg border-none bg-transparent px-0 py-2 text-center text-sm font-bold text-zinc-500 focus:outline-none"
								onClick={() => navigate('/profissional/login')}
							>
								Entrar
							</button>
						</div>
					</div>

					<div className="space-y-6">
						<GoogleButton
							className="w-full max-w-none rounded-xl border-zinc-200 py-3.5 hover:bg-zinc-50"
							onClick={() => {
								const baseUrl =
									import.meta.env.VITE_BACKEND_URL.replace(
										/\/$/,
										'',
									);
								window.location.href = `${baseUrl}/professional-private/login/oauth`;
							}}
						/>

						<div className="space-y-2 text-center">
							<p className="text-xs font-medium text-zinc-400">
								Ao criar uma conta, você concorda com nossos
							</p>
							<button
								type="button"
								onClick={() =>
									openModal({
										title: 'Termos e Condições do Profissional',
										content: <ProfessionalTermsOfUsePage />,
									})
								}
								className="text-xs font-black text-zinc-900 underline-offset-4 hover:underline"
							>
								termos de uso.
							</button>
						</div>
					</div>

					<div className="border-t border-zinc-50 pt-4 text-center">
						<p className="text-xs font-medium text-zinc-400">
							É um cliente?{' '}
							<button
								onClick={() => navigate('/login')}
								className="font-black text-zinc-900 underline-offset-4 hover:underline"
							>
								Acesso Plumaa cliente
							</button>
						</p>
					</div>
				</div>
			</main>
		</div>
	);
};

export { ProfessionalRegister };
